import { render, staticRenderFns } from "./VerifiedInfluencerIcon.vue?vue&type=template&id=a22caf5e"
import script from "./VerifiedInfluencerIcon.vue?vue&type=script&lang=js"
export * from "./VerifiedInfluencerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports